<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.FanCalculation.Title }}
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right">
                <b-button class="button is-primary" @click="openFanPdf">{{ $lang.FanCalculation.ReportBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body fan-body">
                <!-- The screen's one answer, first. Until it arrives, or if it cannot, it says so
                     rather than showing 0.0, which reads as "no fan needed". -->
                <div class="fan-result" :class="{ 'is-failed': calcFailed }" role="status">
                    <p class="fan-result-label" v-html="$lang.FanCalculation.Title_2"></p>
                    <p v-if="fanResult !== null" class="fan-result-value">
                        {{ truncate(fanResult, 1) }}
                        <span class="fan-result-unit" v-html="$lang.FanCalculation.NumFormat"></span>
                    </p>
                    <p v-else class="fan-result-state">
                        {{ calcFailed ? $lang.ResultsInfos.CalcFailed : $lang.ResultsInfos.Pending }}
                    </p>
                </div>

                <!-- The four values it was worked out from. -->
                <div class="fan-inputs">
                    <div v-for="row in inputRows" :key="row.key" class="fan-input-row">
                        <span class="fan-input-label" v-html="row.label"></span>
                        <span class="fan-input-value">{{ row.value }}</span>
                        <span class="fan-input-unit">{{ row.unit }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';

    export default {
        name: 'Fan_Calc',
        components: {
            VerticalStepBar
        },
        data() {
            return {
                isActive: true,

                envTemperature: 0,
                maxTemperature: 0,
                P_890: 0,
                P_Total: 0,
                // null until the API answers
                fanResult: null,
                calcFailed: false,
                P_890Fan: 0,
            }
        },
        mounted() {
            this.envTemperature = this.$store.state.envTemperature;
            this.maxTemperature = this.$store.state.maxTemperature;

            if (this.$store.state.P_890Fan != null && this.$store.state.P_890Fan != undefined) {
                this.P_890Fan = this.$store.state.P_890Fan;
            }
            this.P_890 = this.$store.state.P_890;

            this.P_Total = this.$store.state.P_Total;

            this.calculate_FanResult();
            this.$store.state.activeStep = 5;

            this.$store.state.isFooterFixed = true;
        },
        computed: {
            inputRows() {
                const r = this.$lang.ResultsInfos;
                return [
                    { key: 'Ta', label: r.Ta, value: this.envTemperature, unit: '°C' },
                    { key: 'Tmax', label: r.Tmax, value: this.maxTemperature, unit: '°C' },
                    { key: 'P890', label: r.P890, value: this.truncate(this.P_890Fan, 1), unit: 'W' },
                    { key: 'P', label: r.Title_2, value: this.truncate(this.P_Total, 1), unit: 'W' }
                ];
            }
        },
        watch: {
            $route() {
                this.envTemperature = this.$store.state.envTemperature;
                this.maxTemperature = this.$store.state.maxTemperature;
                this.P_890 = this.$store.state.P_890;
                this.P_890Fan = this.$store.state.P_890Fan;
                this.P_Total = this.$store.state.P_Total;
            }
        },
        methods: {
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/reportPdfPage');
            },
            openFanPdf() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/fanPdfPage');
            },
            calculate_FanResult() {
                var altitude = this.$store.state.altitude;

                api.panels.get_Fan_V_Min(this.envTemperature, this.maxTemperature, this.P_890Fan, this.P_Total, altitude).then((res) => {
                    if (res.isError) {
                        this.calcFailed = true;
                    } else {
                        this.fanResult = res.data;
                    }
                });
            },
            truncate(numToBeTruncated, numOfDecimals) {
                var theNumber = numToBeTruncated.toString();
                if (theNumber.includes('.')) {
                    var pointIndex = theNumber.indexOf('.');
                    var _result = +(theNumber.slice(0, pointIndex > -1 ? ++numOfDecimals + pointIndex : undefined));
                    var _resultString = _result.toString();
                    if (!_resultString.includes('.')) {
                        return _resultString + '.0';
                    } else {
                        return _result;
                    }
                } else {
                    return theNumber + '.0';
                }
            }
        },

    };
</script>
